import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { ViewType } from '@tempo-io/roadmap-dto';
import { getViewsQueryOptions } from '@/lib/queries/view/useView';

export async function redirectToFirstViewOfType({
  type,
  org,
  queryClient,
  roadmapId,
}: {
  type?: ViewType;
  org: string;
  roadmapId: number;
  queryClient: QueryClient;
}): Promise<void> {
  // Fetch views using React Query cache (shared with components)
  const views = await queryClient.ensureQueryData(getViewsQueryOptions(roadmapId));
  const firstView = type ? views.find((view) => view.type === type) : views[0];

  // Redirect to first view if any exist
  if (firstView) {
    throw redirect({
      to: `/org/$org/roadmaps/$roadmapId/view/$viewId/${firstView.type}`,
      params: { org, roadmapId, viewId: firstView.viewId },
      replace: true,
    });
  }
  // fallthrough if no views exist to let the caller render a no-views state
}
